export const configuracoes = {
  data() {
    return {
      exibirMetaMensal: true,
      filtrosAvancados: 0,
      tempoAtualizar: 0,
      atualizarTempoRealParms: [
        { title: 'Não Atualizar', key: 0 },
        { title: '10 minutos', key: 600000 },
        { title: '15 minutos', key: 900000 },
        { title: '20 minutos', key: 1200000 },
        { title: '30 minutos', key: 1800000 },
        { title: '60 minutos', key: 3600000 }
      ]
    };
  },
  computed: {
    preferencias() {
      return {
        exibirMetaMensal: this.exibirMetaMensal,
        filtrosAvancados: this.filtrosAvancados,
        tempoAtualizar: this.tempoAtualizar
      };
    }
  }
};
